var _linearGradient, _style, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBgLetterM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 640"
  }, props), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg_letter_m_svg__gradient",
    x1: 334.83,
    y1: 603.02,
    x2: 119.59,
    y2: 467.05,
    gradientTransform: "matrix(1 0 0 -1 0 642)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afc5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afc5ff",
    stopOpacity: 0
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes dash-ani{0%{stroke-dashoffset:400;opacity:.2}to{stroke-dashoffset:0;opacity:1}}@keyframes move-ani-01{0%{transform:translateY(0)}to{transform:translateY(-20px)}}@keyframes move-ani-02{0%{transform:translateY(0)}to{transform:translateY(20px)}}.bg_letter_m_svg__cls-2{fill:none;stroke-dasharray:3 3;stroke:#afc5ff;stroke-miterlimit:10;opacity:.5}.bg_letter_m_svg__move-01,.bg_letter_m_svg__move-02{animation-name:move-ani-01;animation-duration:1s;animation-iteration-count:infinite;animation-direction:alternate;animation-timing-function:cubic-bezier(.55,.45,.45,.5)}.bg_letter_m_svg__move-02{animation-name:move-ani-02;animation-duration:1.5s}")), /*#__PURE__*/React.createElement("mask", {
    id: "bg_letter_m_svg__mask-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.38-1.87L167.5 179.5",
    style: {
      animationName: "dash-ani",
      animationDuration: "1s",
      animationTimingFunction: "cubic-bezier(.165,.84,.44,1)"
    },
    stroke: "var(--bs-white)",
    strokeWidth: 10,
    strokeDasharray: 400
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    mask: "url(#bg_letter_m_svg__mask-path)",
    d: "M344.38-1.87L167.5 179.5",
    stroke: "url(#bg_letter_m_svg__gradient)",
    fill: "none",
    strokeDasharray: "3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_m_svg__move-01 bg_letter_m_svg__cls-2",
    d: "M154.76 113.32a19.42 19.42 0 01-4.59 7.39 18.91 18.91 0 01-7.33 4.43 29.11 29.11 0 01-9.57 1.58 23.15 23.15 0 01-16.73-6c-4.1-3.88-6.11-9.73-6.11-17.47v-30H122V103a14 14 0 003 9.73 10.88 10.88 0 008.37 3.15 11.09 11.09 0 008.39-3.15 13.21 13.21 0 003-9.46v-30h11.63v29.61a30.31 30.31 0 01-1.63 10.44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_m_svg__move-02",
    d: "M342.75 175.69a16.84 16.84 0 01-4.64 5.82 20.53 20.53 0 01-6.8 3.49 29.87 29.87 0 01-8.35 1.18h-8.87V202h-11.66v-52.72h21.67a26.75 26.75 0 018.52 1.31 18.62 18.62 0 016.36 3.69 16.2 16.2 0 014 5.79 19.29 19.29 0 011.42 7.43v.16a18.93 18.93 0 01-1.67 8.19zm-10.21-7.95a7.06 7.06 0 00-2.54-6 10.93 10.93 0 00-6.91-2h-9v16.11h9.25a9.49 9.49 0 006.88-2.29A7.42 7.42 0 00332 171a7.53 7.53 0 00.6-3.11z",
    strokeOpacity: 0.5,
    stroke: "#afc5ff",
    fill: "none",
    strokeDasharray: "3 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_m_svg__move-01 bg_letter_m_svg__cls-2",
    d: "M76.57 401.77a24.6 24.6 0 01-10.78 4.92 34.2 34.2 0 01-7.21.67 27.85 27.85 0 01-11.17-2.18 26.84 26.84 0 01-8.82-5.86 26.17 26.17 0 01-5.81-8.86 28.3 28.3 0 01-2-11 27.92 27.92 0 017.91-19.55 26.82 26.82 0 018.9-6.17 28.88 28.88 0 0111.46-2.21 35.7 35.7 0 016.92.62 28.63 28.63 0 015.59 1.7 24.18 24.18 0 014.75 2.62 33.93 33.93 0 014.13 3.44l-7.6 8.66a27 27 0 00-6.48-4.47 16.5 16.5 0 00-7.31-1.62 15 15 0 00-6.32 1.31 14.72 14.72 0 00-5 3.63 17 17 0 00-3.15 5.37 18.27 18.27 0 00-1.17 6.5v.17a18.6 18.6 0 001.21 6.54 17.14 17.14 0 003.21 5.39A14.71 14.71 0 0053 395.1a15 15 0 006.23 1.26 17.12 17.12 0 007.87-1.68 30.66 30.66 0 006.4-4.68l7.43 7.63a40.22 40.22 0 01-4.36 4.14zM288.81 469.27V448h-21.64v21.28h-11.74v-53h11.74v21h21.61v-21h11.71v53z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_m_svg__move-02 bg_letter_m_svg__cls-2",
    d: "M39.35 575.29l-4.91-11.93H11.8l-4.9 11.93h-12l22.94-53.59h10.87l23 53.65zm-16.21-39.56L16 553h14.25zM133.43 547.78v-51.5h11.41v51.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "bg_letter_m_svg__move-01 bg_letter_m_svg__cls-2",
    d: "M354.7 641.77l-26.77-34.94v34.94H316v-55h11.21L353 620.66V586.8h12v55z"
  })));
}

export default SvgBgLetterM;